import { render, staticRenderFns } from "./AssignRulesList.vue?vue&type=template&id=1565f4aa&scoped=true&"
import script from "./AssignRulesList.vue?vue&type=script&lang=ts&"
export * from "./AssignRulesList.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRulesList.vue?vue&type=style&index=0&id=1565f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565f4aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VRow,VTooltip})
